import { useEffect, useState } from "react";
import { listDropdowns } from "../Tabellen/ConstTabKopf/BahnhofKopf";
import Modal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { MyModalButtons, MyModalCloseButton, MyModalContentDateInput, MyModalContentNumberInput, MyModalContentRow, MyModalContentSelectInput, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";

var MonitorApi = require('monitor-api');

export default function BhfCreate({ instance, katInstance, typInstance, zvInstance, reloadData }) {
    const [newBahnhof, setNewBahnhof] = useState(new MonitorApi.CreateBahnhof());
    const [dropdowns, setDropdowns] = useState({
        "kategorien": [],
        "typen": [],
        "zweckverbaende": []
    });
    const [showModal, setShowModal] = useState(false);

    useKeypress('Escape', () => {
        closeModal();
    });

    const openModal = () => {
        setNewBahnhof(new MonitorApi.CreateBahnhof());
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    useEffect(() => {
        let loadKategorien = new Promise((result) =>
            katInstance.getBahnhofkategorieBahnhofkategorieGet((error, data, response) => {
                console.log('getKat');
                if (error) {
                    console.error(error);
                } else {
                    result(data)
                }
            })
        )
        let loadTypen = new Promise((result) =>
            typInstance.getBahnhoftypBahnhoftypGet((error, data, response) => {
                console.log('getTyp');
                if (error) {
                    console.error(error);
                } else {
                    result(data);
                }
            })
        )
        let opts = {
            'onlyActive': false // Boolean | 
        };
        let loadZweckverbaende = new Promise((result) =>
            zvInstance.getZweckverbandZweckverbandGet(opts, (error, data, response) => {
                console.log('zv laden')
                if (error) {
                    console.error(error);
                } else {
                    result(data);
                }
            })
        )

        Promise.all([loadKategorien, loadTypen, loadZweckverbaende]).then((values) => {
            const [k, t, z] = values;
            setDropdowns(previous => ({ ...previous, kategorien: k, typen: t, zweckverbaende: z }));
        })
    }, [katInstance, typInstance, zvInstance])

    const changingInput = event => {
        event.preventDefault();
        setNewBahnhof(previous => ({ ...previous, [event.target.name]: event.target.value }))
    }

    const submitForm = event => {
        event.preventDefault();
        let creating = new Promise((resolve) => {
            instance.createBahnhofBahnhofPost(newBahnhof, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Neuer Bahnhof ${data.name} hinzugefügt.\nMit id: ${data.id}`);
                    resolve(data);
                }
            })
        })
        creating.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    const tinkerDropdowns = (acc) => {
        switch (acc) {
            case 'korr_kat':
                return (
                    <MyModalContentSelectInput name="id_kat" onChange={changingInput} required>
                        <option key={0} defaultValue hidden value="">---Auswahl treffen---</option>
                        {dropdowns.kategorien.map(kat => <option value={kat.id} key={kat.id}>{kat.kategorie}</option>)}
                    </MyModalContentSelectInput>
                )
            case 'korr_typ':
                return (
                    <MyModalContentSelectInput name="id_typ" onChange={changingInput} required>
                        <option key={0} defaultValue hidden value="">---Auswahl treffen---</option>
                        {dropdowns.typen.map(t => <option value={t.id} key={t.id}>{t.typ}</option>)}
                    </MyModalContentSelectInput>
                )
            case 'korr_zv':
                return (
                    <MyModalContentSelectInput name="id_zv" onChange={changingInput} required>
                        <option key={0} defaultValue hidden value="">---Auswahl treffen---</option>
                        {dropdowns.zweckverbaende.map(z => <option value={z.id} key={z.id}>{z.name}</option>)}
                    </MyModalContentSelectInput>
                )
            default:
                console.log('Unknown column');
                break;
        }
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neuer Bahnhof</MyNewButton>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={submitForm}>
                    <h3>Neuer Bahnhof:</h3>
                    <MyModalContentRow>
                        <label>Bezeichnung:
                            <MyModalContentTextInput name="bahnhof" onChange={changingInput} required />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Abkürzung:
                            <MyModalContentTextInput name="kurz" onChange={changingInput} required />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>x-Koordinate:
                            <MyModalContentNumberInput min="11.5" max="15.1" step="0.00001" name="xkoord" onChange={changingInput} required />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>y-Koordinate
                            <MyModalContentNumberInput min="50.1" max="52" step="0.00001" name="ykoord" onChange={changingInput} required />
                        </label>
                    </MyModalContentRow>
                    {listDropdowns.map(it =>
                        <MyModalContentRow>
                            <label>{it.Header}:
                                {tinkerDropdowns(it.accessor)}
                            </label>
                        </MyModalContentRow>
                    )}
                    <MyModalContentRow>
                        <label>Gültigkeitsbeginn:
                            <MyModalContentDateInput name="gueltig_von" onChange={changingInput} required />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Gültigkeitsende (optional):
                            <MyModalContentDateInput name="gueltig_bis" min={newBahnhof.gueltig_von} onChange={changingInput} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput name="kommentar" onChange={changingInput} />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </div>
    )
}